enum ViewDialogKey {
    Error = "Error",
    RemoveEntry = "RemoveEntry",
    HistoryDetail = "HistoryDetail",
}

export default ViewDialogKey;